const BACK_PRESSED = "BACK_PRESSED";

let prevBackPressedListener = undefined;
let interceptBackButtonReason = undefined;

window.addEventListener(BACK_PRESSED, function(event) {
    prevBackPressedListener && prevBackPressedListener(event);
});

window.addEventListener('popstate', function (event) {
    if (interceptBackButtonReason) {
        window.dispatchEvent(new Event("BACK_PRESSED"));
        window.history.pushState({noBack: true}, '');
        console.log("back button intercepted for reason: ", interceptBackButtonReason);
    }
});

export function setBackPressedEventListener(listener) {
    prevBackPressedListener = listener;
}

export function clearBackPressedEventListener() {
    prevBackPressedListener = undefined;
}

export function interceptBackButton(reason) {
    interceptBackButtonReason = reason;
    window.history.pushState({noBack: true}, '');
}

export function interceptBackButtonStop() {
    interceptBackButtonReason = undefined;
}



// WEBPACK FOOTER //
// ./src/bridge/back-button.js